import { render } from "./loading2.vue?vue&type=template&id=3fa4539a&scoped=true"
import script from "./loading2.vue?vue&type=script&lang=js"
export * from "./loading2.vue?vue&type=script&lang=js"

import "./loading2.vue?vue&type=style&index=0&id=3fa4539a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa4539a"]])

export default __exports__